module.exports = __webpack_public_path__ + "img/centrifuge-C-light.1a34aaa6.png";